//declare actions
import { combineReducers } from 'redux-immutable';
import { routerReducer } from 'react-router-redux';

import auth from './auth';
import loading from './loading';
//import wall from './wall';
import widget from './widget';
import integration from './integration';
import reviews from './reviews';
import post from './post';
import profile from './profile';
import master from './master';
import billing from './billing';
import activity from './activity';
import visitor from './visitor';
import instaFeed from './instaFeed';

const reducer = combineReducers({
  auth,
  loading,
  // wall,
  integration,
  reviews,
  post,
  profile,
  master,
  widget,
  billing,
  activity,
  visitor,
  instaFeed,
  router: routerReducer
});

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/index.js